/**
 * Common const to handle http requests and responses
 * src/http.js
 */
import axios from 'axios'
import qs from 'qs'
import {LocalStorage} from 'wize-admin'
import store from '@/store'
import router from '@/router'

/**
 *
 * parse error response
 */
function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject(new Error(messages[0]))
    }
    if (messages instanceof Object && messages.detail) {
      // JWT DRF returns an object error response
      return Promise.reject(messages.detail)
    } else {
      return Promise.reject(messages)
    }
  } else {
    return Promise.reject(new Error('Error'))
  }
}

/**
 * parse response
 */
function parseBody(response) {
  if (response.status === 200 || response.status === 201) {
    // Las descargas devuelven la respuesta completa: quien la pide usa
    // response.data como blob. Se mira también responseType porque la cabecera
    // content-disposition solo se puede leer si el backend la expone en CORS,
    // y sin eso las descargas bajaban con "undefined" adentro.
    if (response.headers['content-disposition'] || response.config?.responseType === 'blob')
      return response;
    else
      return response.data;
  } else {
    return parseError(response.data ? response.data.messages : response)
  }
}

/**
 * axios instance
 */
let instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, {indices: false})
  }
})

const requestUseConfig = (config) => {
  if (LocalStorage.getAccessToken() && !config.removeAuth) {
    config.headers['Authorization'] = 'Bearer ' + LocalStorage.getAccessToken();
  }
  // Ciudad activa del nivel 2 (DEF-ADM-009). En Administración (nivel 1) no se envía.
  // Si la request ya trae X-City-Id explícito, se respeta y NO se pisa con la
  // ciudad global.
  const currentCity = store.getters['city/getCurrentCity']
  if (currentCity && !config.headers['X-City-Id']) {
    config.headers['X-City-Id'] = currentCity.id
  }
  return config
}

const responseUseError = function (error) {
  let originalRequest = error.config
  const user = JSON.parse(localStorage.getItem('user'));
  console.error(error)
  if (!error.response) {
    return parseError('Ha ocurrido un error interno, por favor refresque la página')
  } else if (error.response && error.response.status === 401 && user && !originalRequest._retry) {
    originalRequest._retry = true
    store.dispatch('auth/logout');
    router.push({name: 'login'})
    return parseError('Su sesión ha culminado, por favor vuelva a loguearse')
  } else {
    return parseError(error.response.data)
  }

}

// request header
instance.interceptors.request.use(requestUseConfig, error => {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  return parseBody(response);
}, responseUseError)

const http = instance

export {http}
